import * as THREE from 'three';
import * as CANNON from 'cannon-es';

export type PowerupType = 'health' | 'shield' | 'ammo';

export class Powerup {
  public mesh: THREE.Mesh;
  public body: CANNON.Body;
  public type: PowerupType;
  public isActive: boolean = true;
  private rotationSpeed: number = 2;
  private floatOffset: number = 0;
  private floatSpeed: number = 2;

  constructor(x: number, z: number, type: PowerupType) {
    this.type = type;

    // 根据类型选择颜色和形状
    let color: number;
    let geometry: THREE.BufferGeometry;

    switch (type) {
      case 'health':
        color = 0x00ff00;
        geometry = new THREE.BoxGeometry(1, 1, 1);
        break;
      case 'shield':
        color = 0x00ffff;
        geometry = new THREE.OctahedronGeometry(0.7);
        break;
      case 'ammo':
        color = 0xffa500;
        geometry = new THREE.CylinderGeometry(0.5, 0.5, 1, 8);
        break;
    }

    const material = new THREE.MeshStandardMaterial({
      color: color,
      emissive: color,
      emissiveIntensity: 0.5,
      metalness: 0.5,
      roughness: 0.3
    });

    this.mesh = new THREE.Mesh(geometry, material);
    this.mesh.position.set(x, 1.5, z);
    this.mesh.castShadow = true;

    // 创建物理体（传感器，不产生碰撞力）
    const shape = new CANNON.Sphere(0.5);
    this.body = new CANNON.Body({
      mass: 0,
      shape: shape,
      position: new CANNON.Vec3(x, 1.5, z),
      isTrigger: true // 作为触发器
    });

    this.body.userData = { type: 'powerup', powerup: this };

    // 随机初始浮动偏移
    this.floatOffset = Math.random() * Math.PI * 2;
  }

  update(deltaTime: number): void {
    if (!this.isActive) return;

    // 旋转动画
    this.mesh.rotation.y += this.rotationSpeed * deltaTime;

    // 上下浮动动画
    this.floatOffset += this.floatSpeed * deltaTime;
    const floatY = 1.5 + Math.sin(this.floatOffset) * 0.3;

    this.mesh.position.y = floatY;
    this.body.position.y = floatY;

    // 脉冲发光效果
    const material = this.mesh.material as THREE.MeshStandardMaterial;
    material.emissiveIntensity = 0.5 + Math.sin(this.floatOffset * 2) * 0.3;
  }

  collect(): void {
    this.isActive = false;
  }

  getEffect(): { type: PowerupType; value: number } {
    switch (this.type) {
      case 'health':
        return { type: 'health', value: 30 };
      case 'shield':
        return { type: 'shield', value: 10 }; // 10 秒护盾
      case 'ammo':
        return { type: 'ammo', value: 5 }; // 减少射击冷却
    }
  }
}
